// extracted by mini-css-extract-plugin
export var textInput = "_k1-0";